var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('h1',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.privateClassesPage.title')))]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$vuetify.lang.t('$vuetify.privateClassesPage.description'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }